import { render, staticRenderFns } from "./VuesticPageNotFoundSimple.vue?vue&type=template&id=dc6b3fe8"
import script from "./VuesticPageNotFoundSimple.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundSimple.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundSimple.vue?vue&type=style&index=0&id=dc6b3fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports